import React from "react";
import MobileMenuButton from "./sub/MobileMenuButton";
import SearchInput from "./sub/SearchInput";
import MessageButton from "./sub/MessageButton";
import NotificationButton from "./sub/NotificationButton";
import ProfileMenu from "./sub/ProfileMenu";

interface HeaderProps {
  onMenuClick: () => void;
}

const Header: React.FC<HeaderProps> = ({ onMenuClick }) => {
  return (
    <div className="flex mx-auto">
      <header className="sticky top-0 z-40 w-full bg-dark backdrop-blur-md border-b-8 border-l-8 border-secondary rounded-b-2xl sm:rounded-2xl shadow-lg shadow-gray-400 sm:mx-6" >
        <div className="flex items-center justify-between gap-4 px-4 py-3 lg:px-6">
          {/* Left : titre + bouton mobile */}
          <div className="flex items-center gap-3">
            <MobileMenuButton onClick={onMenuClick} />
            <div className="">
              <h1 className="text-xl font-bold text-white tracking-tight sm:hidden flex">Admin</h1>
              <h1 className="text-xl font-bold text-white tracking-tight hidden sm:block">Braincrea Admin</h1>
            </div>
          </div>

          {/* Barre de recherche desktop */}
          <div className="hidden md:flex flex-1 max-w-md">
            <SearchInput className="w-full" />
          </div>

          {/* Actions droite */}
          <div className="flex items-center gap-2">
            <MessageButton />
            <NotificationButton />
            <ProfileMenu />
          </div>
        </div>

      </header>
    </div>
  );
};

export default Header;